import { createFileRoute } from "@tanstack/react-router";
import { DayClosePage } from "../features/reports/day-close-page";
import { Require } from "../features/require";

/** More > Day close (P11-T07), owners, managers and cashiers. */
export const Route = createFileRoute("/more/day-close")({ component: Page });

function Page() {
	return (
		<Require permission="day.close">
			<DayClosePage />
		</Require>
	);
}
